import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import Helpers from '../../../../common/helpers';
import RenderIf from '../../../shared/render-if/components/render-if';

import '../styles/tabs.css';

class Tabs extends Component {
  isInputChecked(tab) {
    const { location } = this.props;

    return location && location.pathname && location.pathname === tab.path;
  }

  renderTabs(tabs) {
    const { t } = this.context;

    if (tabs && tabs.length > 0) {
      return tabs.map((tab, index) => {
        return (
          <div key={index}>
            <input type="radio" onClick={() => Helpers.goToPage(tab.path)} name={`tab_${index}`} id={`tab-${index}`} checked={this.isInputChecked(tab)} />
            <label htmlFor={`tab-${index}`}>{t(tab.text)}</label>
          </div>
        );
      });
    } else return null;
  }

  render() {
    const { tabs } = this.props;

    return (
      <RenderIf if={tabs && tabs.length > 0}>
        <div className="tabset">{this.renderTabs(tabs)}</div>
      </RenderIf>
    );
  }
}

const mapStateToProps = state => ({
  tabs: state.layoutReducer.tabs,
});

const mapDispatchToProps = dispatch => ({});

Tabs.contextTypes = {
  t: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(Tabs);



// WEBPACK FOOTER //
// ./src/app/main/layout/components/tabs.js